import { APP_NAME } from "@storyline/shared";

export const env = {
	SERVER_URL: import.meta.env.VITE_SERVER_URL ?? "http://localhost:8787",
	APP_NAME: import.meta.env.VITE_APP_NAME ?? APP_NAME,
	DEV: import.meta.env.DEV,
};
